export const contentSchema = {
  title: "Content",
  type: "object",
  required: ["key", "value"],
  properties: {
    key: { type: "string", title: "Key" },
    value: { type: "string", title: "Value" },
  },
}
